import { IAttributes } from "types/attributes/attributes.types";

export const GET_ATTRIBUTES_REQUEST = 'GET_ATTRIBUTES_REQUEST';
export const GET_ATTRIBUTES_SUCCESS = 'GET_ATTRIBUTES_SUCCESS';
export const GET_ATTRIBUTES_FAILURE = 'GET_ATTRIBUTES_FAILURE';

export interface GetAttributesRequestAction {
    type: typeof GET_ATTRIBUTES_REQUEST;
    [key: string]: any;
}

export interface GetAttributesSuccessAction {
    type: typeof GET_ATTRIBUTES_SUCCESS;
    payload: IAttributes;
    [key: string]: any;
}

export interface GetAttributesFailureAction {
    type: typeof GET_ATTRIBUTES_FAILURE;
    payload: string;
}

export type AttributesActionTypes =
    | GetAttributesRequestAction
    | GetAttributesSuccessAction
    | GetAttributesFailureAction;

